<template>
  <auth-guard
    route
  >
    <base-title title="PPM Calculator List" />
    <search-filters
      v-model="search"
      :chips="chips"
      @clearChip="clearChipProp"
      @clearFields="clearFields"
      @submitSearch="routePage"
    >
      <v-row>
        <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            label="ID"
            v-model="id"
            type="number"
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
        >
          <v-select
            label="Manual"
            :items="boolOptions"
            v-model="is_manual"
            clearable
            item-text="text"
            item-value="value"
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            label="Name"
            v-model="name"
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            label="Notes"
            v-model="memo"
          />
        </v-col>
      </v-row>
    </search-filters>
    <result-pagination
      v-if="pagination"
      v-model="pagination.page"
      :pages="Math.ceil(totalCount / 20)"
    />
    <v-data-table
      multi-sort
      :headers="headers"
      :items="resultList"
      :server-items-length="totalCount"
      :options.sync="pagination"
      :footer-props="{ 'items-per-page-options': [20] }"
      @page-count="pageCount = $event"
      hide-default-footer
    >
      <template v-slot:item.id="{ item }">
        <router-link-id
          :id="item.id"
          name="ppm-calculation"
        />
      </template>
      <template v-slot:item.is_manual="{ item }">
        {{ item.is_manual ? 'Yes' : 'No' }}
      </template>
      <template v-slot:item.created_at="{ item }">
        {{ item.created_at | formatDate | filterNA }}
      </template>
    </v-data-table>
    <result-pagination
      v-if="pagination"
      v-model="pagination.page"
      :pages="Math.ceil(totalCount / 20)"
    />
    <text-fab
      v-if="$store.getters.can('api.add_ppmcalculation')"
      bottom
      right
      fixed
      icon-text="mdi-plus"
      color="primary"
      @click="$router.push({ name: 'create-ppm-calculation' })"
    >
      Create PPM
    </text-fab>
  </auth-guard>
</template>

<script>
import chipsMixin from '@/base/filter/chipsMixin'
import paginationMixin from '@/base/filter/paginationMixin'
import axios from 'axios'
import SearchFilters from '@/base/filter/SearchFilters'
import ResultPagination from '@/base/components/ResultPagination'

export default {
  mixins: [chipsMixin, paginationMixin],
  name: 'PpmCalculationList',
  components: {
    ResultPagination,
    SearchFilters
  },
  data: function () {
    return {
      pageName: 'ppm-calculation-list',

      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Notes', value: 'memo' },
        { text: 'Manual', value: 'is_manual' }
      ],

      ...this.chipPropagation([
        { name: 'ID', prop: 'id', type: String, query: 'id' },
        { name: 'Name', prop: 'name', type: String, query: 'name__icontains' },
        { name: 'Notes', prop: 'memo', type: String, query: 'memo__icontains' },
        { name: 'Manual', prop: 'is_manual', type: String, query: 'is_manual' }
        // { name: 'ID', prop: 'startDate', type: String, query: 'created_at__gte' },
        // { name: 'ID', prop: 'endDate', type: String, query: 'created_at__lte' }
      ])
    }
  },
  watch: {
    // observes and updated options
    pagination: function (updated) {
      this.routePage(updated)
    }
  },
  methods: {
    async executeSearch () {
      const params = this.getQueryParams()
      params.fields = 'id,name,memo,is_manual'
      axios.get('/api/ppm_calculations/', { params }).then(this.setResponseResults)
    }
  },
  mounted () {
    this.reflectRouteParams()
    this.executeSearch()
  }
}
</script>
